export const INGREDIENT_BAKERS_100PCT = "flour"